import { render, staticRenderFns } from "./lista_porcentaje.vue?vue&type=template&id=444a969c&scoped=true"
import script from "./lista_porcentaje.vue?vue&type=script&lang=js"
export * from "./lista_porcentaje.vue?vue&type=script&lang=js"
import style0 from "./lista_porcentaje.vue?vue&type=style&index=0&id=444a969c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444a969c",
  null
  
)

export default component.exports